import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {
  Error,
  ErrorEstandar
} from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import {
  PersonasJuridica,
  RPEPersonaJuridica
} from './entity-personas-juridica.model';
import { Rol } from '../../roles/entity-roles/roles.model';
import { EntidadesProductiva } from '../entity-entidad-productiva/entity-entidades-productiva.model';

// LOAD
export const entityPersonasJuridicaLoadRequest = createAction(
  '[ENTITYPERSONASJURIDICA] Load Request'
);

export const entityPersonasJuridicaLoadFailure = createAction(
  '[ENTITYPERSONASJURIDICA] Load Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasJuridicaLoadSuccess = createAction(
  '[ENTITYPERSONASJURIDICA] Load Success',
  props<{ items: PersonasJuridica[] }>()
);

// ADD
export const entityPersonasJuridicaAddRequest = createAction(
  '[ENTITYPERSONASJURIDICA] Add Request',
  props<{ item: RPEPersonaJuridica }>()
);

export const entityPersonasJuridicaAddFailure = createAction(
  '[ENTITYPERSONASJURIDICA] Add Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasJuridicaAddSuccess = createAction(
  '[ENTITYPERSONASJURIDICA] Add Success',
  props<{ item: RPEPersonaJuridica }>()
);

// CHANGE
export const entityPersonasJuridicaChangeRequest = createAction(
  '[ENTITYPERSONASJURIDICA] Change Request',
  props<{ item: RPEPersonaJuridica }>()
);

export const entityPersonasJuridicaChangeFailure = createAction(
  '[ENTITYPERSONASJURIDICA] Change Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasJuridicaChangeSuccess = createAction(
  '[ENTITYPERSONASJURIDICA] Change Success',
  props<{ item: { persona: PersonasJuridica, rol: Rol, entidadProductiva: EntidadesProductiva } }>()
);

// DELETE
export const entityPersonasJuridicaDeleteRequest = createAction(
  '[ENTITYPERSONASJURIDICA] Delete Request',
  props<{ item: PersonasJuridica }>()
);

export const entityPersonasJuridicaDeleteFailure = createAction(
  '[ENTITYPERSONASJURIDICA] Delete Failure',
  props<{ error: ErrorEstandar }>()
);

export const entityPersonasJuridicaDeleteSuccess = createAction(
  '[ENTITYPERSONASJURIDICA] Delete Success',
  props<{ item: PersonasJuridica }>()
);
